import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { camps } from '../../models/models.generated';
import { CampCareApiService } from '../../services/api/camp-care-api.service';




@Component({
    selector: 'app-camp-care-booking',
    templateUrl: './camp-care-booking.component.html',
    styleUrls: ['./camp-care-booking.component.scss'],
    standalone: false
})
export class CampCareBookingComponent implements OnInit {

    public searchForm: UntypedFormGroup;
    public camp: camps.CampCareInfo;

    constructor(private activatedRoute: ActivatedRoute
        , private formBuilder: UntypedFormBuilder
        , private campCareApi: CampCareApiService) { }

    ngOnInit() {
        this.initForm();

        this.activatedRoute.params.subscribe(params => {
            if (params.id) {

                this.campCareApi.getInfo(params.id).subscribe(response => {
                    this.camp = response.value;
                    this.searchForm.controls['campId'].setValue(params.id);
                });
            }
        });
    }

    private initForm() {
        this.searchForm = this.formBuilder.group({
            'campId': [null, []],
            'clubId': [null, []],
            'dateFrom': [null, []],
            'dateTo': [null, []]
        });
    }
}
